<template>
    <section class="projectCont">

        <div class="projectLogo_cont" ref="exTarget" @mouseover="slideActive = true" @mouseleave="slideActive = false" :data-active="slideActive" >
            <h2 class="projName" >{{ projectData.title }}</h2>
            <img v-for="(img, i) in projectData.icon" :src="img" :key="i" @click="openImg(img)" alt="project image" class="projectLogo" />
        </div>

        <p class="projDesc" v-html="projectData.desc"></p>

        <div class="projDet">
            <div class="projTech">
                <h3 :style="{marginBottom: '15px'}">Tool stack:</h3>

                <div
                    class="projTech_cont"
                    v-for="(tool, x) in projectData.tools"
                    :key="x"
                >
                <div class="iconCont">
                    <img :src="getIcon(tool)" class="skillIcon" />
                    <p>{{ tool }}</p>
                </div>
                </div>
            </div>

            <div
                class="projTech collab"
                v-if="projectData.colaborator.length > 0 && projectData.colaborator[0] != ''"
            >
                <h3>Collaborators:</h3>

                <a v-for="(colaborator, z) in projectData.colaborator" :key="z" :href="colaborator[2]" target="_blank">
                    <div>
                        <img :src="colaborator[1]" alt="collaborator">
                        <p>{{colaborator[0]}}</p>
                    </div>
                </a>
            </div>

            <div class="projTech">
                <reactionControl
                    v-bind:reactions="[projectData.points, projectData._id, true]"
                />
            </div>

            <div class="projFooter" v-if="projectData.open">
                <h3>Project available on Github</h3>
                <a target="_blank" :href="projectData.source">{{projectData.source}}</a>
            </div>
        </div>
    </section>
</template>

<script>

import reactionControl from './reactionControl.vue';

export default {
    props: {
        projectData: Object,
        tools: Object
    },

    components: {
        reactionControl
    },

    data() { 
        return {
            slideActive: false,
            slideVisible: false,
            imgInterval: null
        }
    },

    methods: {
        getIcon(name) {
            for (let i = 0; i < this.tools.known.length; i++) {
                if (this.tools.known[i][1] == name) {
                return this.tools.known[i][0];
                }
            }

            for (let i = 0; i < this.tools.diving.length; i++) {
                if (this.tools.diving[i][1] == name) {
                return this.tools.diving[i][0];
                }
            }

            for (let i = 0; i < this.tools.db.length; i++) {
                if (this.tools.db[i][1] == name) {
                return this.tools.db[i][0];
                }
            }

            for (let i = 0; i < this.tools.lang.length; i++) {
                if (this.tools.lang[i][1] == name) {
                return this.tools.lang[i][0];
                }
            }
        },
        imageExchange() {
            let container = this.$refs.exTarget;
            let imgCollection = container.getElementsByTagName("img");
            
            let index = 0;
            let beforeIndex = 0;

            for(let image of imgCollection) {
            if(index == 0) {
                index = 1; 
                continue;
            }
            image.style.display = "none";
            }

            if(imgCollection.length == 1) return;

            this.imgInterval = setInterval(() => {
                if(!this.slideVisible) return;
            
                imgCollection[index].style.display = "block";

                if(beforeIndex != undefined) imgCollection[beforeIndex].style.display = "none";

                beforeIndex = index;
                index = index+1;

                if(index > imgCollection.length -1) index = 0;
            }, 3500);

            this.isInViewport(container);
        },
        isInViewport(el) {
            const observer = new window.IntersectionObserver(([entry]) => {
                if (entry.isIntersecting) {
                    return this.slideVisible = true;
                }
                return this.slideVisible = false;
            }, {
                root: null,
                threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
            })

            observer.observe(el);
        },
        openImg(img) {
            window.open(img, '_blank');
        }
    },

    mounted() {
        if(this.projectData.icon.length >= 2) {
            this.imageExchange();
        }
    },

    beforeDestroy() {
        clearInterval(this.imgInterval);
    }
}
</script>

<style scoped lang="scss">
    
    .collab {
        h3 {
            margin-bottom: 10px;
        }
        div {
            border: 1px solid rgba(0, 0, 0, 0.25);
            background-color: rgba(255, 255, 255, 0.4);
            display: inline-block;
            display: flex;
            max-width: 207px;
            align-items: center;
            overflow: hidden;
            padding: 3px;

            img {
                height: 50px;
                width: 50px;
                object-fit: cover;
                border-radius: 50%;
            }
            p {
                font-weight: bold;
                font-size: 17px;
                margin: 0 10px;

                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1; /* number of lines to show */
                line-clamp: 2; 
                -webkit-box-orient: vertical;
                text-align: initial;

                cursor: pointer;
            }
        }
        a {
            background-color: unset;
            color: #000;
            padding: 0;
            margin: 0;
            text-decoration: none;
            display: inline-block;
            margin: 7px;
        }
    }
    .projectCont {
        width: 75%;
        height: auto;
        padding: 0px 0 10px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 5px;
        box-shadow: 0px 0px 5px #000000ab;
        -webkit-backdrop-filter: blur(6.2px);
        backdrop-filter: blur(6.2px);
        margin: 20px 0 40px 0;
        overflow: hidden;
        transition: background-color .4s;
    }

    .projectLogo_cont {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 350px;
        max-height: 350px;
        width: 100%;
        overflow: hidden;
        margin-bottom: 15px;

        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    .projectLogo_cont .projectLogo {
        height: 100%;
        width: 100%;
        max-height: 400px;
        min-height: 400px;
        object-fit: cover;
        object-position: center center;
        transform: scale(1.5);
        isolation: isolate;
        background: #fff;
        opacity: .3;
        transition: .9s;
        animation: showImage .5s linear;
        cursor: pointer;
    }

    [data-active=true] .projectLogo {
        animation: hoverShowImage .5s linear !important;
    }

    .projectLogo_cont:hover .projectLogo {
        transform: scale(1);
        opacity: .8;
    }

    .projectLogo_cont:hover .projName {
        font-size: 70px;
        opacity: .2;
        transition: .7s;
    }

    .projectLogo_cont .projName {
        white-space: nowrap;
        font-size: 60px;
        position: absolute;
        z-index: 10;
        transition: .5s;
        text-shadow: 0 0 10px #fff;
        pointer-events: none;
        user-select: none;
    }

    .projFooter {
        border-top: 1px solid #000;
        margin-top: 15px;
        padding: 5px 15px;
        width: 100%;
        min-width: 235px;
        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .projFooter p {
        margin-bottom: 8px;
    }

    .projFooter a,
    a {
        text-decoration: none;
        color: #fff;
        background: #000;
        padding: 1px 7px;
        font-weight: bold;
        margin-top: 10px;
    }

    .projDesc {
        text-align: justify;
        margin: 0 60px 0 60px;
    }

    .projTech {
        border-top: 1px solid #000;
        margin-top: 20px;
        padding: 5px 5px;
        min-width: 235px;
        width: 100%;
    }

    .projTech_cont {
        display: inline-flex;
        max-width: 130px;
        margin: 10px 15px;

    }

    .projDet {
    width: 65%;
    display: flex;
    flex-direction: column;
    align-items: center;
    }

    .skillIcon {
        mix-blend-mode: exclusion;
        will-change: opacity;
        height: 60px;
        width: 60px;
        margin: 0 10px;
        border-radius: 50%;
        filter: invert(1);
        object-fit: cover;
        transition: opacity 0.7s;
    }

    .iconCont {
        border-radius: 50%;
        width: 90px;
        height: 75px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 15px;
        background-color: #000000ce;
        transition: .4s;
        box-shadow: -2px 0px 5px black;

        p {
            font-size: 11px;
            color: #fff;
        }

        img {
            width: 40px;
            height: 40px;
            margin-bottom: 2px;
        }
    }
    
    @keyframes hoverShowImage {
        from {
            opacity: .3;
        }
        to {
            opacity: .8;
        }
    }

    @keyframes showImage {
        from {
            opacity: .0;
        }
        to {
            opacity: .3;
        }
    }

    @media (prefers-color-scheme: dark) {
        .projectCont {
            background-color: #00000044;
        }

        .iconCont {
            background-color: #000000ce;
        }
    }

    @media (prefers-color-scheme: light) {
        .projectCont {
            background-color: #ffffff44;
        }

        .iconCont {
            background-color: #ffffffce;
            p {
                color: #000;
            }
        }
    }

    @media screen and (max-width: 900px) {
        .projectCont {
            width: 90%;
            margin: 10px 0 25px 0;
        }
    }

    @media screen and (max-width: 800px) {
    .projectLogo_cont .projectLogo {
        height: 100%;
        width: 100%;
        max-height: 300px;
        min-height: 300px;
        object-fit: cover;
        object-position: center center;
        transform: scale(1.5);
        isolation: isolate;
        background: #fff;
        opacity: .3;
        transition: .9s;
    }

    .projectLogo_cont .projName {
        font-size: 30px;
    }

    .projectLogo_cont:hover .projName {
        font-size: 40px;
    }

    .projFooter {
        border-top: 1px solid #000;
        margin-top: 15px;
        padding: 5px 15px;
        width: 100%;
        min-width: 300px;
        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .projFooter p {
        margin-bottom: 8px;
    }

    .projFooter a,
    a {
        text-decoration: none;
        color: #fff;
        background: #000;
        padding: 1px 7px;
        font-weight: bold;
    }


    .projTech {
        border-top: 1px solid #000;
        margin-top: 30px;
        padding: 5px 15px;
        min-width: 300px;
        width: 100%;
    }

    .projTech_cont {
        padding-top: 5px;
    }

    .projDet {
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    }

    @media screen and (max-width: 500px) {
        
        .skillIcon {
            height: 50px;
            width: 50px;
            margin: 0 5px;
        }

        .projDesc {
            margin: 0 15px;
        }
        .projDet {
            width: 90%;
        }

        .projectCont {
            width: 97%;
            margin: 7px 0;
        }

        .projFooter {
            border-top: 1px solid #000;
            margin-top: 15px;
            padding: 5px 15px;
            width: 100%;
            min-width: 285px;
            overflow: hidden;

            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .projFooter p {
            margin-bottom: 8px;
        }

        .projFooter a,
        a {
            text-decoration: none;
            color: #fff;
            background: #000;
            padding: 1px 7px;
            font-weight: bold;
        }

        .projFooter a {
            font-size: 14px;
        }

        .projTech {
            border-top: 1px solid #000;
            margin-top: 30px;
            padding: 5px 15px;
            min-width: 285px;
            width: 100%;
        }

        .projTech_cont {
            padding-top: 5px;
        }

    }

    @media screen and (max-width: 385px) {
    .projectCont {
        width: 96%;
        margin: 6px 0;
    }

    .projectLogo_cont {
        min-height: 300px;
        max-height: 300px;
    }

    .projectLogo_cont .projectLogo {
        height: 100%;
        width: 100%;
        max-height: 400px;
        min-height: 400px;
        object-fit: cover;
        object-position: center center;
        transform: scale(1.5);
        isolation: isolate;
        background: #fff;
        opacity: .3;
        transition: .9s;
    }


    .projFooter {
        border-top: 1px solid #000;
        margin-top: 15px;
        padding: 5px 15px;
        width: 100%;
        min-width: 285px;
        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .projFooter p {
        margin-bottom: 8px;
    }

    .projFooter a,
    a {
        text-decoration: none;
        color: #fff;
        background: #000;
        padding: 1px 7px;
        font-weight: bold;
    }

    .projFooter a {
        font-size: 14px;
    }

    .projTech {
        border-top: 1px solid #000;
        margin-top: 30px;
        padding: 5px 15px;
        min-width: 285px;
        width: 95%;
    }

    .projTech_cont {
        padding-top: 5px;
    }

    .projDet {
        width: 88%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    }

    @media screen and (max-width: 350px) {
    .projectCont {
        width: 96%;
        margin: 6px 0;
        overflow: hidden;
    }


    .projectLogo_cont {
        min-height: 200px;
        max-height: 200px;
    }

    .projectLogo_cont .projectLogo {
        height: 100%;
        width: 100%;
        max-height: 300px;
        min-height: 300px;
        object-fit: cover;
        object-position: center center;
        transform: scale(1.5);
        isolation: isolate;
        background: #fff;
        opacity: .3;
        transition: .9s;
    }

    .projectLogo_cont .projName {
        font-size: 30px;
    }

    .projectLogo_cont:hover .projName {
        font-size: 40px;
    }

    .projFooter {
        border-top: 1px solid #000;
        margin-top: 15px;
        padding: 5px 15px;
        width: 100%;
        min-width: 285px;
        overflow: hidden;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .projFooter p {
        margin-bottom: 8px;
    }

    .projFooter a,
    a {
        text-decoration: none;
        color: #fff;
        background: #000;
        padding: 1px 7px;
        font-weight: bold;
    }

    .projFooter a {
        font-size: 14px;
    }


    .projTech {
        border-top: 1px solid #000;
        margin-top: 30px;
        padding: 5px 15px;
        min-width: 285px;
        width: 100%;
    }

    .projTech_cont {
        padding-top: 5px;
    }

    .projDet {
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    }
</style>